import React from 'react'
import { Grid } from '@mui/material'

function GOTAbout() {

    return (
        <div style={{ fontFamily: 'Raleway', fontSize: 20, marginLeft: 30, marginRight: 40 }}>
            <Grid container>
                <Grid item xs={12}>
                    <a href="#menu" className="navPanelToggle"><span className="fa fa-bars"></span></a>






                    <p>One of the greatest gifts you can give is the <br></br><b>gift of time</b>.</p>
                    <p>Redefining work to harness latent talent<br></br></p>
                </Grid>
                <p><b>1 million</b>  citizens</p>
                &nbsp;
                <p><b>25 million</b> untapped human hours by 2024</p>

                <Grid item xs={12}>
                    <header>
                        <h2>Purpose</h2>
                    </header>
                </Grid>
                <p>To engage for a not for profit purpose which shall include, initiate, plan, implement, aid and assist activities directed towards enhancing the work life, by enabling people to clock in their currently unrecorded hours of expertise, passion, hobby, community service in the area of healthcare, education, legal, financial, accounting, sports, leisure, entertainment, spiritual, and acts of charity into a time asset. To create a social enterprise that will benefit our currently excluded workforce and provide job opportunities to seniors, homemakers and youth to constructively contribute their available skills and time to productivity that’s flexible and result oriented.</p>






                <Grid item xs={12}>
                    <header>
                        <h2>Principles</h2>
                    </header>
                </Grid>
                <p>Everyone has something of value to share with someone else irrespective of their age, gender, circumstances or qualification.
                    <br></br>
                    Today building strong families, inclusive workforces and revitalising the earth or our neighbors is not considered work.<br></br>

                    Helping people to get comfortable with receiving and giving to further goodwill.</p>








                <br></br>


                <br></br>



                <Grid item xs={4}>
                    <header>
                        <h2>Socials</h2>
                    </header>

                    <a href="https://www.instagram.com/giftoftime_/" rel="noreferrer" target="_blank">Instagram</a>
                    <br></br>
                    <a href="https://www.facebook.com/" rel="noreferrer" target="_blank">Facebook</a><br></br>
                    <a href="mailto:siyakohli@gmail.com" rel="noreferrer" target="_blank">E-mail</a><br></br>
                    <a href="https://www.linkedin.com/company/gift-of-time-foundation-in/" target="_blank" rel="noreferrer">LinkedIn</a>
                </Grid>





                <br></br>



                <Grid item md={4} xs={12}>
                    <header>
                        <h2>E-mail</h2>
                    </header>



                    <p><a href="mailto:arorashar@icloud.com" rel="noreferrer" target="_blank">arorashar@icloud.com</a><br></br>
                        <a href="mailto:padmakuchibhotla95@gmail.com" rel="noreferrer" target="_blank">padmakuchibhotla95@gmail.com</a>
                    </p>
                </Grid>
                <Grid item xs={12}>
                    <h2> Address</h2>
                    #580, Phase 3, Adarsh Palm Retreat Phase 3 Outer, road, Devarabisinahalli, Bellandur, Bangalore 560103
                </Grid>
                <Grid item xs={12}>
                    <header>
                        <h2>Phone</h2>
                    </header>


                    <p>Call us at</p>
                    <p>+919606052523<br></br>
                        +919844246680
                    </p>
                </Grid>
            </Grid>
        </div>


    )



}

export default GOTAbout